// Acquisition attribution for CRM lead submissions (first-party analytics).
//
// Gatsby is an SPA: the ?gclid/utm_* params on the LANDING url are gone by the time
// the visitor reaches a listing page and submits the enquiry form. So we snapshot
// them once per session on entry (first-touch wins) and attach them to the lead
// payload at submit time, together with the tracker's visitor id (rcrm_vid) so the
// CRM can retro-stitch this browser's anonymous pre-submit journey to the new lead.
//
// Server contract: /api/weblisting/leads/create accepts utm_*, gclid/fbclid/msclkid/
// wbraid/gbraid/ttclid, tracking_referrer and page_url (see the CRM's
// docs/2026-08-28-analytics-attribution-integration.md). All best-effort + SSR-safe.

const KEYS = [
  "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content",
  "gclid", "fbclid", "msclkid", "wbraid", "gbraid", "ttclid",
];
const STORE = "rcrm_attribution";

/** Call once on client entry: persist the first-touch params for the session. */
export const captureAttribution = () => {
  if (typeof window === "undefined") return;
  try {
    if (sessionStorage.getItem(STORE)) return; // first touch wins
    const qs = new URLSearchParams(window.location.search);
    const snap = {};
    KEYS.forEach((k) => {
      const v = qs.get(k);
      if (v) snap[k] = v;
    });
    if (document.referrer) snap.tracking_referrer = document.referrer;
    snap.landing_page = window.location.href;
    sessionStorage.setItem(STORE, JSON.stringify(snap));
  } catch (e) {
    /* storage unavailable — attribution is best-effort */
  }
};

/** Merge into the lead payload at submit time. */
export const attributionPayload = () => {
  if (typeof window === "undefined") return {};
  let out = {};
  try {
    out = JSON.parse(sessionStorage.getItem(STORE) || "{}");
  } catch (e) { /* ignore */ }
  try {
    // Tracker visitor id → lets the CRM stitch the anonymous journey to the lead.
    const vid = window.localStorage ? localStorage.getItem("rcrm_vid") : null;
    if (vid) out.analytics_vid = vid;
  } catch (e) { /* ignore */ }
  if (!out.page_url) {
    try { out.page_url = window.location.href; } catch (e) { /* ignore */ }
  }
  return out;
};
